import classNames from 'classnames/bind';
import styles from './LanguageSelector.module.css';
import { languages } from '../../locales/i18n';
import { LANGUAGE } from '../../constants';
import { useEffect, useRef, useState } from 'react';
import { useSelect } from '../../hooks/useSelect';
import { useTranslation } from 'react-i18next';
import { VITE_SHOW_LANGUAGE_SELECTOR } from '../../utils/util';

interface LanguageSelector {
  location?: string;
}

interface Language {
  code: string;
  locale: string;
  name: string;
}

export default function LanguageSelector({ location }: LanguageSelector) {
  if (VITE_SHOW_LANGUAGE_SELECTOR === 'false') return null;

  const cx = classNames.bind(styles);
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const curLang = languages.find(
    ({ code, locale }) => i18n.language === `${code}-${locale}`
  );
  const [curLangName, setCurLangName] = useState(curLang?.name);
  const selectRef = useRef(null);

  const changedLanguage = async (
    e: React.MouseEvent,
    { code, locale, name }: Language
  ) => {
    setIsOpen(false);
    await i18n.changeLanguage(`${code}-${locale}`);
    setCurLangName(name);
    window.location.reload();
  };

  useSelect(selectRef, () => setIsOpen(false));

  useEffect(() => {
    document.documentElement.lang = i18n.language || 'ko-KR';
  }, []);

  return (
    <div className={cx('language_box', location)}>
      <em>{LANGUAGE}:</em>
      <span className={cx('select_wrap')} ref={selectRef}>
        <span
          role="button"
          className={cx('btn', 'select_toggle')}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className={cx('setting_option')}>
            <i className={cx('lang_flag_kr')}></i>
            {curLangName}
          </span>
        </span>
        {isOpen && (
          <span className={cx('select_menu')}>
            <ul className={cx('select_list')}>
              {languages.map((lang) => (
                <li
                  key={lang.code}
                  className={cx('items')}
                  onClick={(e) => changedLanguage(e, lang)}
                >
                  <span>{lang.name}</span>
                </li>
              ))}
            </ul>
          </span>
        )}
      </span>
    </div>
  );
}
